import { PATIENT_HIGHLIGHTS_QUERY } from 'src/components/general/PatientMenu/highlights/patientHighlights.gql';
import useTypedSWR from 'src/components/general/useTypedSWR';

export const useSWRPatientHighlights = (patientId: string) =>
  useTypedSWR([PATIENT_HIGHLIGHTS_QUERY, { patientId }]);
